import { WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { AccountMembershipsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { BankAccountMembershipSelector } from 'modules/banking/components/BankAccountMembershipSelector'
import { WizardData } from 'modules/banking/components/FinishSetupAccountModal/types'
import { WizardStepLayoutF0 } from 'modules/banking/components/FinishSetupAccountModal/wizardSteps/WizardStepLayoutF0'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

import { AccountMembershipsInfo } from './AccountMembershipsInfo'

interface FinishSetupMembershipsWizardStepF0Props extends WizardStepRenderParams<WizardData> {
  accountId?: string
}

export const FinishSetupMembershipsWizardStepF0 = ({
  data,
  onDataChanged,
  accountId,
}: FinishSetupMembershipsWizardStepF0Props) => {
  const handleSelectEmployees = (selection: EmployeeSelectorV2MultiSelectState) => {
    onDataChanged({ ...data, employeeSelection: selection })
  }

  const { data: membershipsData } = useQuery(AccountMembershipsDocument, {
    variables: { accountIds: accountId ? [accountId] : [] },
    skip: !accountId,
  })

  const memberships = membershipsData?.banking.accountMemberships ?? []

  return (
    <WizardStepLayoutF0
      title={i18n.t('banking.accounts.finish_wizard.step_3.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_3.subtitle')}
    >
      <BankAccountMembershipSelector onChange={handleSelectEmployees} />
      {accountId && <AccountMembershipsInfo memberships={memberships} />}
    </WizardStepLayoutF0>
  )
}
